import {
    Grid,
    GridItem,
    FormControl,
    FormLabel,
    FormErrorMessage,
    Input,
    Text,
    Stack,
    forwardRef,
    InputGroup,
    InputRightElement,
    IconButton,
    Icon,
} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { useForm } from 'react-hook-form'

import {
    useGetMergedJobSeekerQuery,
    useUpsertManualWatchListMutation,
} from '../../api'

import { SearchIcon } from '@/assets/icon'
import {
    RoundedModal,
    RoundedModalContent,
    RoundedModalHeader,
    RoundedModalBody,
    RoundedModalFooter,
    ModalOverlay,
    ModalCloseButton,
    ModalButton,
} from '@/components/Elements'
import { useDashboard, useDashboardDispatch } from '@/features/dashboard'
import { getUserId } from '@/features/auth'

const normalize = (value) => {
    const original = value || ''
    return original
        .trim()
        .replace(
            /[Ａ-Ｚａ-ｚ０-９]/g,
            (c) => String.fromCharCode(c.charCodeAt(0) - 0xfee0) // 全角半角変換
        )
        .toUpperCase()
}

export const ResisterModal = () => {
    const { modal } = useDashboard()
    const dispatch = useDashboardDispatch()
    return (
        <RoundedModal
            size="lg"
            isOpen={modal === 'resister'}
            onClose={() => dispatch({ type: 'RESISTER', payload: false })}
        >
            <ModalOverlay />
            <RoundedModalContent>
                <RoundedModalHeader>候補者の追加</RoundedModalHeader>
                <Content />
            </RoundedModalContent>
        </RoundedModal>
    )
}
ResisterModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
}

const Content = () => {
    const [query, setQuery] = useState()
    const {
        handleSubmit,
        register,
        reset,
        formState: { isDirty, errors },
    } = useForm()
    const { currentData, isError } = useGetMergedJobSeekerQuery(query, {
        skip: !query || isDirty,
    })

    // console.log({ isDirty, currentData, errors })
    return (
        <>
            <RoundedModalBody>
                <Stack gap={8}>
                    <Text>
                        SFに登録されている候補者情報を取得し追加します。
                    </Text>
                    <JobSeekerInfoContainer
                        as="form"
                        onSubmit={handleSubmit((data) => {
                            const normalized = normalize(data.sfid)
                            setQuery(normalized)
                            reset({ sfid: normalized })
                        })}
                    >
                        <FormControl
                            isInvalid={isError || errors.sfid}
                            display="contents"
                        >
                            <Title
                                as={FormLabel}
                                m={0}
                                fontSize="inherit"
                                fontWeight="inherit"
                            >
                                候補者SFID
                            </Title>
                            <Value as={InputGroup} w="242px">
                                <Input
                                    type="tel"
                                    pr="40px"
                                    {...register('sfid', { required: true })}
                                />
                                <InputRightElement>
                                    <IconButton
                                        variant="unstyled"
                                        aria-label="検索"
                                        color="tryt.primary-1"
                                        type="submit"
                                        icon={
                                            <Icon as={SearchIcon} w={6} h={6} />
                                        }
                                    />
                                </InputRightElement>
                            </Value>
                            <GridItem colStart={3} colEnd={4}>
                                <FormErrorMessage>
                                    正しいSFIDを入力してください
                                </FormErrorMessage>
                            </GridItem>
                        </FormControl>
                        {/* ここから求職者情報の表示 */}
                        <JobSeekerInfo data={currentData} />
                    </JobSeekerInfoContainer>
                    {/* <FormControl isInvalid={updateResult.isError}>
                        <FormErrorMessage>
                            データの登録に失敗しました
                        </FormErrorMessage>
                    </FormControl> */}
                </Stack>
            </RoundedModalBody>
            <RoundedModalFooter>
                <ModalCloseButton />
                <SubmitButton
                    isDisabled={!currentData}
                    currentData={currentData}
                >
                    確定
                </SubmitButton>
            </RoundedModalFooter>
        </>
    )
}

export const JobSeekerInfoContainer = forwardRef((props, ref) => {
    return (
        <Grid
            ref={ref}
            alignItems="center"
            templateColumns="auto auto 1fr"
            gap={2}
            fontSize="md"
            fontWeight="medium"
            {...props}
        />
    )
})

export const JobSeekerInfo = ({ data }) => {
    const address =
        data?.prefecture || data?.city
            ? [data?.prefecture, data?.city].filter(Boolean).join(' ')
            : '-'
    return (
        <>
            <Title>名前</Title>
            <Value>{setValuesJobSeeker(data?.name)}</Value>
            <Title>居住地</Title>
            <Value>{address}</Value>
            <Title>性別</Title>
            <Value>{setValuesJobSeeker(data?.sex)}</Value>
            <Title>年齢</Title>
            <Value>{setValuesJobSeeker(data?.age)}</Value>
            <Title>優先資格</Title>
            <Value>{setValuesJobSeeker(data?.qualifications)}</Value>
        </>
    )
}
JobSeekerInfo.propTypes = {
    data: PropTypes.any,
}

const setValuesJobSeeker = (value) => {
    return value ? value : '-'
}

const Title = forwardRef(({ children, ...props }, ref) => {
    return (
        <>
            <GridItem ref={ref} color="tryt.gray-4" {...props}>
                {children}
            </GridItem>
            <GridItem color="tryt.gray-4">：</GridItem>
        </>
    )
})

const Value = forwardRef((props, ref) => {
    return <GridItem ref={ref} {...props} />
})

const SubmitButton = forwardRef(({ currentData, ...props }, ref) => {
    const dispatch = useDashboardDispatch()
    const [addClient, { isLoading }] = useUpsertManualWatchListMutation()
    return (
        <ModalButton
            ref={ref}
            variant="gradient"
            {...props}
            isLoading={isLoading}
            onClick={() => {
                addClient({
                    userId: getUserId(),
                    jobseekerSfId: currentData?.sfId,
                })
                    .unwrap()
                    .then(() => {
                        dispatch({ type: 'RESISTER', payload: false })
                    })
            }}
        />
    )
})
